import { watch, ref, computed } from 'vue';
import { useStore } from 'vuex';

export default r => {
  const store = useStore();
  const { role } = store.getters.homelandInfo;

  const authMap = {
    home_owner: 1,
    home_manager: 2,
    home_member: 3
  };

  return authMap[role] < authMap[r];
};

export const hasAuth = code => {
  const store = useStore();
  const result = ref((store.getters.operates ?? []).includes(code));

  watch(
    () => store.getters.operates,
    val => {
      console.log(val, code, 'operates');
      result.value = (val ?? []).includes(code);
    }
  );

  console.log(store.getters.operates, code, result.value, 'operates');

  return result;
};

export const useAuthFn = (code, fn, isReady = true) => {
  const store = useStore();

  const effectInfo = computed(() => {
    return {
      authIsReady: store.getters.authIsReady,
      operates: store.getters.operates,
      isReady
    };
  });
  watch(
    () => effectInfo.value,
    val => {
      console.log(val.authIsReady, val, val.operates, '------');
      fn &&
        val.authIsReady &&
        val.isReady &&
        fn((val.operates ?? []).includes(code));
    },
    {
      immediate: true,
      deep: true
    }
  );
};
